import { render, staticRenderFns } from "./choosePeople.vue?vue&type=template&id=7daf96df&scoped=true&"
import script from "./choosePeople.vue?vue&type=script&lang=js&"
export * from "./choosePeople.vue?vue&type=script&lang=js&"
import style0 from "./choosePeople.vue?vue&type=style&index=0&id=7daf96df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf96df",
  null
  
)

export default component.exports